import { readCookie } from "../utils/helpers";
import { LOCALE } from "./constants";
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const getGoogleClientId = () => {
  return process.env.REACT_APP_GOOGLE_CLIENT_ID;
};

export const getFacebookClientId = () => {
  return process.env.REACT_APP_FACEBOOK_CLIENT_ID;
};
export const userGuid = () => {
  let userguid = readCookie("userguid");
  if (!!userguid) {
    return userguid.toLocaleLowerCase();
  } else {
  }
};

export const determineTraitLevel = (score) => {
  // Determine the level based on score
  if (score > 6.25) return "3"; // High
  if (score > 4.75) return "2"; // Mid/Normal
  return "1"; // Moderate
};

export const removeWhitespace = (text, replacement = "") => {
  return text ? text.replace(/\s+/g, replacement) : "";
};

export const wrapScoresWithTraitLevel = (userTraits) => {
  return userTraits.map((item) => ({
    score: determineTraitLevel(item.score),
    title: item.trait.title,
  }));
};

export const generateContentKey = (mappedUserTrait) => {
  if (mappedUserTrait.length === 0) return "";

  // Create an object to store the scores for each trait
  const scoreMap = {};

  // Populate the scoreMap based on the input
  mappedUserTrait.forEach((item) => {
    const trait = item.title;
    const score = item.score;

    // For each trait, add the corresponding score
    scoreMap[trait] = score;
  });

  // Build the result string for the traits in the correct order
  const resultTraits = [
    scoreMap["E"] ? "E" : "I", // Choose E if present, otherwise I
    scoreMap["S"] ? "S" : "N", // Choose S if present, otherwise N
    scoreMap["T"] ? "T" : "F", // Choose T if present, otherwise F
    scoreMap["J"] ? "J" : "P", // Choose J if present, otherwise P
  ].join("");

  // Build the score string for the same order
  const resultScores = [
    scoreMap["E"] || scoreMap["I"], // Use the score for E or I
    scoreMap["S"] || scoreMap["N"], // Use the score for S or N
    scoreMap["T"] || scoreMap["F"], // Use the score for T or F
    scoreMap["J"] || scoreMap["P"], // Use the score for J or P
  ].join("");
  return `${resultTraits}_${resultScores}`;
};

export const enneagramRank = {
  theadvocate: 1,
  thecollaborator: 2,
  theentrepreneur: 3,
  themaverick: 4,
  theinspector: 5,
  thestalwart: 6,
  theadmirer: 7,
  thedefier: 8,
  themediator: 9,
};

export const CareerPreferenceRank = {
  healthcare_and_medicine: 1,
  information_technology_it_and_software: 2,
  administration_and_management: 3,
  manufacturing: 4,
  legal_services: 5,
  banking_and_finance: 7,
  engineering: 8,
  trades_and_construction: 8,
  government: 9,
  sales: 10,
  transportation_and_logistics: 11,
  education: 12,
  research_and_science: 13,
  pharmaceutical: 14,
  marketing_and_public_relations: 15,
  human_resources: 16,
  food_and_beverage: 17,
  agriculture: 18,
  telecommunications: 19,
  architecture: 20,
  security_and_investigations: 21,
  hospitality_and_tourism: 22,
  media_and_communications: 23,
  automotive: 24,
  art_and_design: 25,
  civic_and_social_organization: 26,
  sports_and_physical_training: 27,
  real_estate: 28,
  care_services: 29,
  veterinary_and_animal_care: 30,
  entertainment: 31,
  fashion_and_cosmetics: 32,
  music: 33,
};

export const enneagramWings = [
  {
    section: "theadvocate",
    wings: ["thecollaborator", "themediator"],
  },
  {
    section: "thecollaborator",
    wings: ["theadvocate", "theentrepreneur"],
  },
  {
    section: "theentrepreneur",
    wings: ["thecollaborator", "themaverick"],
  },
  {
    section: "themaverick",
    wings: ["theentrepreneur", "theinspector"],
  },
  {
    section: "theinspector",
    wings: ["themaverick", "thestalwart"],
  },
  {
    section: "thestalwart",
    wings: ["theinspector", "theadmirer"],
  },
  {
    section: "theadmirer",
    wings: ["thestalwart", "thedefier"],
  },
  {
    section: "thedefier",
    wings: ["theadmirer", "themediator"],
  },
  {
    section: "themediator",
    wings: ["theadvocate", "thedefier"],
  },
];
export const enneagramDisplayTraits = (title) => {
  const enneagramNames = {
    theadvocate: "The Advocate",
    thecollaborator: "The Collaborator",
    theentrepreneur: "The Entrepreneur",
    themaverick: "The Maverick",
    theinspector: "The Inspector",
    thestalwart: "The Stalwart",
    theadmirer: "The Admirer",
    thedefier: "The Defier",
    themediator: "The Mediator",
  };

  return enneagramNames[title?.toLowerCase()] || title; // Return formatted name or fallback
};
export const enneagramChartConfiguration = {
  labels: [
    "theadvocate",
    "thecollaborator",
    "theentrepreneur",
    "themaverick",
    "theinspector",
    "thestalwart",
    "theadmirer",
    "thedefier",
    "themediator",
  ],
  colors: {
    theadvocate: "rgba(255, 99, 132, 0.8)",
    thecollaborator: "rgba(54, 162, 235, 0.8)",
    theentrepreneur: "rgba(255, 206, 86, 0.8)",
    themaverick: "rgba(75, 192, 192, 0.8)",
    theinspector: "rgba(153, 102, 255, 0.8)",
    thestalwart: "rgba(255, 159, 64, 0.8)",
    theadmirer: "rgba(201, 203, 207, 0.8)",
    thedefier: "rgba(123, 239, 178, 0.8)",
    themediator: "rgba(250, 128, 114, 0.8)",
  },
};

export const filterEnneagramTraitsAndGenerateKey = (
  contentKey,
  userTraits,
  enneagramWings,
) => {
  // Find the primary wings based on the contentKey
  const primaryWings = enneagramWings?.find(
    (wing) => wing?.section === contentKey,
  );

  // Filter user traits that match the primary wings
  const filterWings = userTraits?.filter((item) => {
    return primaryWings?.wings.includes(item?.trait?.title);
  });

  // Generate content key for the filtered wings
  const filterPrimaryWings = generateContentKeyForEnneagram(filterWings);

  const filterSecondaryWings = primaryWings?.wings
    .filter((item) => {
      // Check if the item is NOT included in filterPrimaryWings
      return !filterPrimaryWings.includes(item);
    })
    .join(", ");

  // Return the filtered traits and the generated content key
  return {
    primaryWings: filterPrimaryWings,
    secondaryWings: filterSecondaryWings,
  };
};

export const generateContentKeyForEnneagram = (USER_TRAITS) => {
  if (USER_TRAITS.length === 0) return "";

  // Find the maximum score
  const maxScore = Math.max(...USER_TRAITS.map((trait) => trait.score));

  // Filter traits that have the maximum score
  const maxScoreTraits = USER_TRAITS.filter(
    (trait) => trait.score === maxScore,
  );

  // If there are multiple traits with the same max score, find the one with the highest rank
  const highestRankTrait = maxScoreTraits.reduce((prev, current) => {
    // Compare ranks using the enneagramRank object
    return enneagramRank[prev.trait.title] < enneagramRank[current.trait.title]
      ? prev
      : current;
  });

  // Return the title of the trait with the highest rank
  return highestRankTrait.trait.title;
};

export const generateContentKeyForAssessment = (USER_TRAITS, assessmentId) => {
  if (USER_TRAITS.length === 0) return "";

  // Find the maximum score
  const maxScore = Math.max(...USER_TRAITS.map((trait) => trait.score));

  // Filter traits that have the maximum score
  const maxScoreTraits = USER_TRAITS.filter(
    (trait) => trait.score === maxScore,
  );

  let highestRankTrait;

  // Check the assessmentId to determine which logic to apply
  if (
    assessmentId.toLowerCase() === ENNEAGRAM_TEST_ASSESSMENT_ID.toLowerCase()
  ) {
    // If there are multiple traits with the same max score, find the one with the highest rank
    highestRankTrait = maxScoreTraits.reduce((prev, current) => {
      // Compare ranks using the enneagramRank object
      return enneagramRank[prev.trait.title] <
        enneagramRank[current.trait.title]
        ? prev
        : current;
    });

    // Return the title of the trait with the highest rank
    return highestRankTrait.trait.title;
  } else if (
    assessmentId.toLowerCase() ===
    CAREER_PREFERENCE_TEST_ASSESSMENT_ID.toLowerCase()
  ) {
    // Logic for Career Preference Test
    highestRankTrait = maxScoreTraits.reduce((prev, current) => {
      // Compare ranks using the CareerPreferenceRank object
      return CareerPreferenceRank[prev.trait.title] <
        CareerPreferenceRank[current.trait.title]
        ? prev
        : current;
    });

    // Return the title of the trait with the highest rank
    return highestRankTrait.trait.title;
  }

  // If the assessmentId does not match any known IDs, return an empty string or handle accordingly
  return "";
};

export const FacebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
export const AppleCliendId = process.env.REACT_APP_APPLE_CLIENT_ID; // TODO: Replace with {TEAM_ID}.{SERVICE_ID}, e.g. "ABC123DEF.com.insightfultraits.web.signin"

export const getAppleRedirectUrl = () => {
  return process.env.REACT_APP_APPLE_REDIRECT_URL;
};
export const AppleRedirectUrl = getAppleRedirectUrl();

export const getTokenExIframeJs = () => {
  return `${process.env.REACT_APP_AZURE_BLOB_URL}/cdn/assets/js/tokenEXscript.js${process.env.REACT_APP_CDN_SIGN}`;
};

export const TRUSTPILOT_SCRIPT =
  "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const PERSONALITY_TEST_ASSESSMENT_ID =
  "2faff0c7-50a3-4827-baa1-cc70892fa9f2";

export const BIG_FIVE_TEST_ASSESSMENT_ID =
  "5f7b7cfe-2909-4b7f-872e-8694d6eeba7a";

export const BIG_FIVE_FACETS_TEST_ASSESSMENT_ID =
  "c0a19fec-b7e9-4a62-b7a9-bf0e14cc9a60";

export const ENNEAGRAM_TEST_ASSESSMENT_ID =
  "15f84d33-674b-4c94-9dde-679ee35e5e3e";

export const LIKEABILITY_TEST_ASSESSMENT_ID =
  "a6cdaff9-c5aa-4b3a-986a-e921a6f4b039";

export const FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID =
  "14fdbd79-20fa-4bbc-9ddd-41154e05c50f";

export const DISC_TEST_ASSESSMENT_ID = "53f74b1a-5fa7-4e47-bccf-8c2e58665cfb";

export const ROMANTIC_COMPATIBILITY_ASSESSMENT_ID =
  "36a83d0c-3ffa-49ce-aa4f-cddb506f3849";

export const EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID =
  "ef64c4ee-8a5e-437b-af4a-bb4c64058e4e";

export const DIFFICULT_PERSON_TEST_ASSESSMENT_ID =
  "8ac26067-d34a-4555-ac67-91a66302c592";

export const AUTISM_SPECTRUM_TEST_ASSESSMENT_ID =
  "c091c6ff-efad-47a9-9361-b8348ac04374";

export const HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID =
  "74360864-de6f-4efb-973a-b079f6c102c5";
export const ATTACHMENT_STYLE_TEST_ASSESSMENT_ID =
  "094ce345-33d3-4fb7-b83b-2c936c27f68a";

export const PERSONALITY_DISORDER_TEST_ASSESSMENT_ID =
  "01566bbd-c926-4e41-a4be-3a805c9aa144";

export const CAREER_PREFERENCE_TEST_ASSESSMENT_ID =
  "4e72fc41-98fa-4833-8009-98899478caa2";

export const DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID =
  "6a3ee87e-b813-4f88-9112-87cad5ec3442";

export const DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID =
  "f36d99da-24df-4733-978b-42162c8ffa8a";

export const ADHD_TEST_ASSESSMENT_ID = "848ec3d6-46b6-4da5-81b8-27b8dea2172c";

export const LOVE_STYLE_TEST_ASSESSMENT_ID =
  "7b9dba34-4dbb-4d66-ae15-9f24b32f21c6";

export const NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID =
  "4fef133f-15b7-4f0a-9093-b8c4392df684";

export const ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID =
  "25c9b45f-2fca-4016-8170-5388c7e28280";

export const CAREER_TEST_ASSESSMENT_ID = "a2181cc3-3772-453c-bcee-9e650213fb8a";

export const COLOR_BLINDNESS_TEST_ASSESSMENT_ID =
  "b3af8311-46ea-4411-936f-2fa562834273";
export const DEPRESSION_TEST_ASSESSMENT_ID =
  "a4b88654-1c09-45af-8972-8c938a7223b3";
export const BIPOLAR_DISORDER_ASSESSMENT_ID =
  "ce519758-b424-488e-af59-aaf0edea7d1b";
export const PSYCHOPATH_ASSESSMENT_ID = "ee8d6899-784d-4fec-b1d8-4e9d8a1c0f57";
export const CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID =
  "845a8640-8b31-4aa5-9d23-619eb592736c";

export const AUTISM_CHILDREN_TEST_ASSESSMENT_ID =
  "c1e4dbcc-a23c-4983-89c4-ffc97519ff02";

export const CHECKOUT_AB_TEST_ID = "1BD0E8CB-AB83-48DA-95AC-58EE2AE8C685";

export const DASHBOARD_AB_TEST_ID = "1359A0B6-EC2F-48F4-9452-42C582489CF0";

export const SOCIAL_ANXIETY_TEST_ASSESMENT_ID =
  "c5c4946d-8154-4071-9471-9a57199d177b";
export const IQ_TEST_ASSESSMENT_ID = "0ab6dcde-f253-4b3c-baca-76746ba7c496";
export const SOCIOPATH_TEST_ASSESSMENT_ID =
  "1ab4f116-bf53-4255-aada-ef5690329da2";
export const PHOBIAS_TEST_ASSESSMENT_ID =
  "35207228-fb8b-4437-828c-bd30ad4dc02a";
export const FALSE_PLAN_MAX_USER_COUNT = 3;

export const COUNTRY_CODE = {
  USA: "US",
  UK: "GB",
  CANADA: "CA",
  INDIA: "IN",
};

// export const cdnUrl = () => {
//   const cdnUrl = {
//     QA: "https://insightfulplatform.blob.core.windows.net/cdn",
//     PRODUCTION: "https://insightfulplatformprod.blob.core.windows.net/cdn",
//     STAGING: "https://insightfulplatformprod.blob.core.windows.net/cdn",
//     DEVELOPMENT: "https://insightfulplatform.blob.core.windows.net/cdn",
//   };
//   return cdnUrl[currentEnv];
// };

// CDN Sign utility
export const cdnUrl = () => {
  return `${process.env.REACT_APP_AZURE_BLOB_URL}/cdn`;
};

export const cdnBaseUrl = () => {
  return process.env.REACT_APP_AZURE_BLOB_URL;
};

// Blob utility
const CONTENT_PATH = "content/assessments/images/colorblind/questions";

export const contentPathUrl = () => {
  return `${process.env.REACT_APP_AZURE_BLOB_URL}/${CONTENT_PATH}/`;
};

export const cdnSign = () => {
  return process.env.REACT_APP_CDN_SIGN;
};

export const MODEL_TYPE_DASHBOARD = {
  [LOCALE.EN]: "dashboardhome",
  [LOCALE.ES]: "dashboardhome_ES",
  [LOCALE.JA]: "dashboardhome_JA",
  [LOCALE.FR]: "dashboardhome_FR",
  [LOCALE.IT]: "dashboardhome_IT",
};

export const MODEL_TYPE_CAREER_CONTENT = {
  [LOCALE.EN]: "CareerFieldPreContentModel",
  [LOCALE.ES]: "CareerFieldPreContentModel_ES",
  [LOCALE.JA]: "CareerFieldPreContentModel_JA",
  [LOCALE.FR]: "CareerFieldPreContentModel_FR",
  [LOCALE.IT]: "CareerFieldPreContentModel_IT",
};

export const MODEL_TYPE_BIG_FIVE = {
  [LOCALE.EN]: "BigFivePersonalityTypeModel",
  [LOCALE.ES]: "BigFivePersonalityTypeModel_ES",
  [LOCALE.JA]: "BigFivePersonalityTypeModel_JA",
  [LOCALE.FR]: "BigFivePersonalityTypeModel_FR",
  [LOCALE.IT]: "BigFivePersonalityTypeModel_IT",
};

export const MODEL_TYPE_BIG_FIVE_FACETS = {
  [LOCALE.EN]: "BigFiveFacetsTypeModel",
  [LOCALE.ES]: "BigFiveFacetsTypeModel_ES",
  [LOCALE.JA]: "BigFiveFacetsTypeModel_JA",
  [LOCALE.FR]: "BigFiveFacetsTypeModel_FR",
  [LOCALE.IT]: "BigFiveFacetsTypeModel_IT",
};

export const MODEL_TYPE_ENNEAGRAM = {
  [LOCALE.EN]: "EnneagramTypeModel",
  [LOCALE.ES]: "EnneagramTypeModel_ES",
  [LOCALE.JA]: "EnneagramTypeModel_JA",
  [LOCALE.FR]: "EnneagramTypeModel_FR",
  [LOCALE.IT]: "EnneagramTypeModel_IT",
};

export const MODEL_TYPE_DIFFICULT_PERSON = {
  [LOCALE.EN]: "DifficultpersonTypeModel",
  [LOCALE.ES]: "DifficultpersonTypeModel_ES",
  [LOCALE.JA]: "DifficultpersonTypeModel_JA",
  [LOCALE.FR]: "DifficultpersonTypeModel_FR",
  [LOCALE.IT]: "DifficultpersonTypeModel_IT",
};

export const MODEL_TYPE_CAREER_PREFERENCE = {
  [LOCALE.EN]: "CareerTasksTypeModel",
  [LOCALE.ES]: "CareerTasksTypeModel_ES",
  [LOCALE.JA]: "CareerTasksTypeModel_JA",
  [LOCALE.FR]: "CareerTasksTypeModel_FR",
  [LOCALE.IT]: "CareerTasksTypeModel_IT",
};

export const MODEL_TYPE_EMOTIONAL_INTELLIGENCE = {
  [LOCALE.EN]: "EmotionalIntelligenceTypeModel",
  [LOCALE.ES]: "EmotionalIntelligenceTypeModel_ES",
  [LOCALE.JA]: "EmotionalIntelligenceTypeModel_JA",
  [LOCALE.FR]: "EmotionalIntelligenceTypeModel_FR",
  [LOCALE.IT]: "EmotionalIntelligenceTypeModel_IT",
};

export const MODEL_TYPE_FOUR_TEMPERAMENT = {
  [LOCALE.EN]: "FourTemperamentsTypeModel",
  [LOCALE.ES]: "FourTemperamentsTypeModel_ES",
  [LOCALE.JA]: "FourTemperamentsTypeModel_JA",
  [LOCALE.FR]: "FourTemperamentsTypeModel_FR",
  [LOCALE.IT]: "FourTemperamentsTypeModel_IT",
};

export const MODEL_TYPE_ADHD = {
  [LOCALE.EN]: "AdhdTypeModel",
  [LOCALE.ES]: "AdhdTypeModel_ES",
  [LOCALE.JA]: "AdhdTypeModel_JA",
  [LOCALE.FR]: "AdhdTypeModel_FR",
  [LOCALE.IT]: "AdhdTypeModel_IT",
};

export const MODEL_TYPE_DISC = {
  [LOCALE.EN]: "DISCTypeModel",
  [LOCALE.ES]: "DISCTypeModel_ES",
  [LOCALE.JA]: "DISCTypeModel_JA",
  [LOCALE.FR]: "DISCTypeModel_FR",
  [LOCALE.IT]: "DISCTypeModel_IT",
};

export const MODEL_TYPE_LIKEABILITY = {
  [LOCALE.EN]: "LikeabilityTypeModel",
  [LOCALE.ES]: "LikeabilityTypeModel_ES",
  [LOCALE.JA]: "LikeabilityTypeModel_JA",
  [LOCALE.FR]: "LikeabilityTypeModel_FR",
  [LOCALE.IT]: "LikeabilityTypeModel_IT",
};

export const MODEL_TYPE_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "PersonalitydisorderTypeModel",
  [LOCALE.ES]: "PersonalitydisorderTypeModel_ES",
  [LOCALE.JA]: "PersonalitydisorderTypeModel_JA",
  [LOCALE.FR]: "PersonalitydisorderTypeModel_FR",
  [LOCALE.IT]: "PersonalitydisorderTypeModel_IT",
};

export const MODEL_TYPE_AUTISM_SPECTRUM = {
  [LOCALE.EN]: "AutismadultsTypeModel",
  [LOCALE.ES]: "AutismadultsTypeModel_ES",
  [LOCALE.JA]: "AutismadultsTypeModel_JA",
  [LOCALE.FR]: "AutismadultsTypeModel_FR",
  [LOCALE.IT]: "AutismadultsTypeModel_IT",
};
export const MODEL_TYPE_ATTACHMENT_STYLE = {
  [LOCALE.EN]: "AttachmentTypeModel",
  [LOCALE.ES]: "AttachmentTypeModel_ES",
  [LOCALE.JA]: "AttachmentTypeModel_JA",
  [LOCALE.FR]: "AttachmentTypeModel_FR",
  [LOCALE.IT]: "AttachmentTypeModel_IT",
};
export const MODEL_TYPE_LOVE_STYLE = {
  [LOCALE.EN]: "LovestyleTypeModel",
  [LOCALE.ES]: "LovestyleTypeModel_ES",
  [LOCALE.JA]: "LovestyleTypeModel_JA",
  [LOCALE.FR]: "LovestyleTypeModel_FR",
  [LOCALE.IT]: "LovestyleTypeModel_IT",
};
export const MODEL_TYPE_NARCISSISTIC_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "NarcissisticTypeModel",
  [LOCALE.ES]: "NarcissisticTypeModel_ES",
  [LOCALE.JA]: "NarcissisticTypeModel_JA",
  [LOCALE.FR]: "NarcissisticTypeModel_FR",
  [LOCALE.IT]: "NarcissisticTypeModel_IT",
};
export const MODEL_TYPE_ANTISOCIAL_PERSONALITY_DISORDER = {
  [LOCALE.EN]: "AntisocialTypeModel",
  [LOCALE.ES]: "AntisocialTypeModel_ES",
  [LOCALE.JA]: "AntisocialTypeModel_JA",
  [LOCALE.FR]: "AntisocialTypeModel_FR",
  [LOCALE.IT]: "AntisocialTypeModel_IT",
};

export const MODEL_TYPE_HIGHLY_SENSITIVE_PERSON = {
  [LOCALE.EN]: "HighlysensitivepersonTypeModel",
  [LOCALE.ES]: "HighlysensitivepersonTypeModel_ES",
  [LOCALE.JA]: "HighlysensitivepersonTypeModel_JA",
  [LOCALE.FR]: "HighlysensitivepersonTypeModel_FR",
  [LOCALE.IT]: "HighlysensitivepersonTypeModel_IT",
};

export const MODEL_TYPE_DYSLEXIA_SCREENING_CHILDREN = {
  [LOCALE.EN]: "DyslexiachildrenTypeModel",
  [LOCALE.ES]: "DyslexiachildrenTypeModel_ES",
  [LOCALE.JA]: "DyslexiachildrenTypeModel_JA",
  [LOCALE.FR]: "DyslexiachildrenTypeModel_FR",
  [LOCALE.IT]: "DyslexiachildrenTypeModel_IT",
};

export const MODEL_TYPE_DYSLEXIA_SCREENING_ADULT = {
  [LOCALE.EN]: "DyslexiaadultsTypeModel",
  [LOCALE.ES]: "DyslexiaadultsTypeModel_ES",
  [LOCALE.JA]: "DyslexiaadultsTypeModel_JA",
  [LOCALE.FR]: "DyslexiaadultsTypeModel_FR",
  [LOCALE.IT]: "DyslexiaadultsTypeModel_IT",
};

export const CONTENT_KEY_BIG_FIVE = "ALL_CONTENT";

export const MODEL_TYPE_CAREER = {
  [LOCALE.EN]: "CareerFieldTypeModel",
  [LOCALE.ES]: "CareerFieldTypeModel_ES",
  [LOCALE.JA]: "CareerFieldTypeModel_JA",
  [LOCALE.FR]: "CareerFieldTypeModel_FR",
  [LOCALE.IT]: "CareerFieldTypeModel_IT",
};

export const MODEL_ROMANTIC_PERSONALIZED = {
  [LOCALE.EN]: "RomanticCompatibilityPersonalTypeModel",
  [LOCALE.ES]: "RomanticCompatibilityPersonalTypeModel_ES",
  [LOCALE.JA]: "RomanticCompatibilityPersonalTypeModel_JA",
  [LOCALE.FR]: "RomanticCompatibilityPersonalTypeModel_FR",
  [LOCALE.IT]: "RomanticCompatibilityPersonalTypeModel_IT",
};
export const MODEL_ROMANTIC_COMPATIBILITY = {
  [LOCALE.EN]: "RomanticCompatibilityTypeModel",
  [LOCALE.ES]: "RomanticCompatibilityTypeModel_ES",
  [LOCALE.JA]: "RomanticCompatibilityTypeModel_JA",
  [LOCALE.FR]: "RomanticCompatibilityTypeModel_FR",
  [LOCALE.IT]: "RomanticCompatibilityTypeModel_IT",
};

export const MODEL_TYPE_COLOR_BLIND = {
  [LOCALE.EN]: "ColorBlindTypeModel",
  [LOCALE.ES]: "ColorBlindTypeModel_ES",
  [LOCALE.JA]: "ColorBlindTypeModel_JA",
  [LOCALE.FR]: "ColorBlindTypeModel_FR",
  [LOCALE.IT]: "ColorBlindTypeModel_IT",
};

export const MODEL_TYPE_DEPRESSION = {
  [LOCALE.EN]: "DepressionTypeModel",
  [LOCALE.ES]: "DepressionTypeModel_ES",
  [LOCALE.JA]: "DepressionTypeModel_JA",
  [LOCALE.FR]: "DepressionTypeModel_FR",
  [LOCALE.IT]: "DepressionTypeModel_IT",
};

export const MODEL_TYPE_BIPOLAR_DISORDER = {
  [LOCALE.EN]: "BipolarDisorderTypeModel",
  [LOCALE.ES]: "BipolarDisorderTypeModel_ES",
  [LOCALE.JA]: "BipolarDisorderTypeModel_JA",
  [LOCALE.FR]: "BipolarDisorderTypeModel_FR",
  [LOCALE.IT]: "BipolarDisorderTypeModel_IT",
};

export const MODEL_TYPE_PSYCHOPATH = {
  [LOCALE.EN]: "PsychopathTypeModel",
  [LOCALE.ES]: "PsychopathTypeModel_ES",
  [LOCALE.JA]: "PsychopathTypeModel_JA",
  [LOCALE.FR]: "PsychopathTypeModel_FR",
  [LOCALE.IT]: "PsychopathTypeModel_IT",
};
export const MODEL_TYPE_CHILDHOOD_TRAUMA = {
  [LOCALE.EN]: "ChildhoodTraumaTypeModel",
  [LOCALE.ES]: "ChildhoodTraumaTypeModel_ES",
  [LOCALE.JA]: "ChildhoodTraumaTypeModel_JA",
  [LOCALE.FR]: "ChildhoodTraumaTypeModel_FR",
  [LOCALE.IT]: "ChildhoodTraumaTypeModel_IT",
};

export const MODEL_TYPE_SOCIAL_ANXIETY = {
  [LOCALE.EN]: "SocialAnxietyTypeModel",
  [LOCALE.ES]: "SocialAnxietyTypeModel_ES",
  [LOCALE.JA]: "SocialAnxietyTypeModel_JA",
  [LOCALE.FR]: "SocialAnxietyTypeModel_FR",
  [LOCALE.IT]: "SocialAnxietyTypeModel_IT",
};

export const MODEL_TYPE_AUTISM_CHILDREN = {
  [LOCALE.EN]: "AutismChildTypeModel",
  [LOCALE.ES]: "AutismChildTypeModel_ES",
  [LOCALE.JA]: "AutismChildTypeModel_JA",
  [LOCALE.FR]: "AutismChildTypeModel_FR",
  [LOCALE.IT]: "AutismChildTypeModel_IT",
};

export const MODEL_TYPE_PHOBIAS = {
  [LOCALE.EN]: "PhobiasTestTypeModel",
  [LOCALE.ES]: "PhobiasTestTypeModel_ES",
  [LOCALE.JA]: "PhobiasTestTypeModel_JA",
  [LOCALE.FR]: "PhobiasTestTypeModel_FR",
  [LOCALE.IT]: "PhobiasTestTypeModel_IT",
};

export const planPageABTestID = "1175D61E-5EB6-41DE-A0AE-FF35F4C3B6DB";

export const plan1995 = "MAB1995";

export const noTestImage = () => {
  return `${process.env.REACT_APP_AZURE_BLOB_URL}/cdn/assets/images/no-test-image.svg${process.env.REACT_APP_CDN_SIGN}`;
};

export const getBigFiveTraitResultCode = (score, traitCode) => {
  if (!score || !traitCode || score < 1 || score > 5) {
    return "Invalid input";
  }

  const scoreRanges = [
    { upper: 5, lower: 4.6, suffix: "_H" },
    { upper: 4.6, lower: 3.53, suffix: "_AA" },
    { upper: 3.53, lower: 2.47, suffix: "_A" },
    { upper: 2.47, lower: 1.4, suffix: "_BA" },
    { upper: 1.4, lower: 1, suffix: "_L" },
  ];

  // const validTraits = new Set(["E", "A", "O", "C", "N"]);
  // if (!validTraits.has(traitCode)) {
  //   return `Invalid trait code: ${traitCode}`;
  // }
  // Adjust the range check to include `score === 1`
  const matchingRange = scoreRanges.find((range) =>
    range.lower === 1
      ? score <= range.upper && score >= range.lower
      : score <= range.upper && score > range.lower,
  );

  // const matchingRange = scoreRanges.find(
  //   (range) => score <= range.upper && score > range.lower
  // );

  return matchingRange
    ? `${traitCode}${matchingRange.suffix}`
    : `No matching result found for score: ${score}`;
};

export const BIG_FIVE_TRAITS_LONG_NAME = {
  E: "Extraversion",
  O: "Openness",
  A: "Agreeableness",
  C: "Conscientiousness",
  N: "Neuroticism",
};

export const traitTitleKeyMap = {
  [LOCALE.EN]: "title",
  [LOCALE.ES]: "title_ES",
  [LOCALE.JA]: "title_JA",
  [LOCALE.FR]: "title_FR",
  [LOCALE.IT]: "title_IT",
};

export const traitNameKeyMap = {
  [LOCALE.EN]: "name",
  [LOCALE.ES]: "name_ES",
  [LOCALE.JA]: "name_JA",
  [LOCALE.FR]: "name_FR",
  [LOCALE.IT]: "name_IT",
};

export const labelKeyMap = {
  [LOCALE.EN]: "label",
  [LOCALE.ES]: "label_ES",
  [LOCALE.JA]: "label_JA",
  [LOCALE.FR]: "label_FR",
  [LOCALE.IT]: "label_IT",
};

export const contentSign = () => {
  return process.env.REACT_APP_CONTENT_SIGN;
};

export const MODEL_TYPE_SOCIOPATH = {
  [LOCALE.EN]: "SociopathTestTypeModel",
  [LOCALE.ES]: "SociopathTestTypeModel_ES",
  [LOCALE.JA]: "SociopathTestTypeModel_JA",
  [LOCALE.FR]: "SociopathTestTypeModel_FR",
  [LOCALE.IT]: "SociopathTestTypeModel_IT",
};

// Confirmed contentModelType for the real IQ report content
// (contentKey: "ALL_CONTENT"). Only the EN value is confirmed — other
// locale suffixes follow the established `${base}_XX` convention but are
// not yet verified; MODEL_TYPE_IQ[currentLocale] || MODEL_TYPE_IQ[LOCALE.EN]
// falls back to EN for any unconfirmed locale.
export const MODEL_TYPE_IQ = {
  [LOCALE.EN]: "IQTypeModel",
  [LOCALE.ES]: "IQTypeModel_ES",
  [LOCALE.JA]: "IQTypeModel_JA",
  [LOCALE.FR]: "IQTypeModel_FR",
  [LOCALE.IT]: "IQTypeModel_IT",
};
export const IQ_CONTENT_KEY = "ALL_CONTENT";

// //parameter usertraits

export const ROMANTIC_COMPATIBILITY_TRAIT_KEY_MAP = {
  communication_style: "CommunicationStyle",
  emotional_compatibility: "EmotionalCompatibility",
  lifestyle_preferences: "LifestylePreferences",
  conflict_resolution: "ConflictResolution",
  core_values_and_beliefs: "CoreValuesAndBeliefs",
  intimacy_and_affection: "IntimacyAndAffection",
  independence_vs_togetherness: "IndependenceBalance",
  financial_philosophy: "FinancialPhilosophy",
  ambition_and_growth: "AmbitionAndGrowth",
  family_and_social_dynamics: "FamilyAndSocialDynamics",
  adventure_and_exploration: "AdventureAndExploration",
  conflict_triggers: "ConflictTriggers",
};

export const getAssessmentOverviewModelType = (assessmentId) => {
  const map = {
    [BIPOLAR_DISORDER_ASSESSMENT_ID]: "BipolarDisorderTypeModel_Overview",
    [COLOR_BLINDNESS_TEST_ASSESSMENT_ID]: "ColorBlindTypeModel_Overview",
    [LOVE_STYLE_TEST_ASSESSMENT_ID]: "LoveStyleTypeModel_Overview",
    [PERSONALITY_TEST_ASSESSMENT_ID]: "PersonalityTypeModel_Overview",
    [BIG_FIVE_TEST_ASSESSMENT_ID]: "BigFiveTypeModel_Overview",
    [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: "BigFiveFacetsTypeModel_Overview",
    [ENNEAGRAM_TEST_ASSESSMENT_ID]: "EnneagramTypeModel_Overview",
    [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: "DifficultPersonTypeModel_Overview",
    [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]: "CareerTasksTypeModel_Overview",
    [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]:
      "EmotionalIntelligenceTypeModel_Overview",
    [FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID]:
      "FourTemperamentsTypeModel_Overview",
    [ADHD_TEST_ASSESSMENT_ID]: "AdhdTypeModel_Overview",
    [DISC_TEST_ASSESSMENT_ID]: "DISCTypeModel_Overview",
    [LIKEABILITY_TEST_ASSESSMENT_ID]: "LikeabilityTypeModel_Overview",
    [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]:
      "PersonalityDisorderTypeModel_Overview",
    [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: "AutismAdultsTypeModel_Overview",
    [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: "AttachmentTypeModel_Overview",
    [NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID]:
      "NarcissisticTypeModel_Overview",
    [ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID]:
      "AntisocialTypeModel_Overview",
    [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]:
      "HighlySensitivePersonTypeModel_Overview",
    [DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID]:
      "DyslexiaChildrenTypeModel_Overview",
    [DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID]:
      "DyslexiaAdultsTypeModel_Overview",
    [DEPRESSION_TEST_ASSESSMENT_ID]: "DepressionTypeModel_Overview",
    [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]:
      "RomanticCompatibilityTypeModel_Overview",
    [CAREER_TEST_ASSESSMENT_ID]: "CareerFieldTypeModel_Overview",
    [PSYCHOPATH_ASSESSMENT_ID]: "PsychopathTypeModel_Overview",
    [CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID]: "ChildhoodTraumaTypeModel_Overview",
    [SOCIAL_ANXIETY_TEST_ASSESMENT_ID]: "SocialAnxietyTypeModel_Overview",
    [AUTISM_CHILDREN_TEST_ASSESSMENT_ID]: "AutismChildTypeModel_Overview",
    [SOCIOPATH_TEST_ASSESSMENT_ID]:
      "SociopathTestTypeModel_Overview",
    [IQ_TEST_ASSESSMENT_ID]: "IQTypeModel_Overview",
  };

  const base = map[assessmentId];

  if (!base) return null;

  return {
    [LOCALE.EN]: base,
    [LOCALE.ES]: `${base}_ES`,
    [LOCALE.JA]: `${base}_JA`, // ✅ added JA
    [LOCALE.FR]: `${base}_FR`,
    [LOCALE.IT]: `${base}_IT`,
  };
};

export const ASSESSMENT_OVERVIEW_CONTENT_KEY = "OVERVIEW_CONTENT";

export const getGoogleCaptchaKey = () => {
  return process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;
};

export const invalidMailboxStatuses = ["mailbox_not_found", "no_mailbox"];

export const currentPortalCDForCaptcha = "IT";
